export const languages = [
  "arabic",
  "english",
  "french",
  "spanish",
  "german",
  "italian",
  "portuguese",
  "russian",
  "chinese",
  "japanese",
  "korean",
  "vietnamese",
  "thai",
  "indonesian",
  "bengali",
  "malay",
  "tagalog",
  "telugu",
  "tamil",
  "urdu",
  "marathi",
  "bhojpuri",
  "punjabi",
  "gujarati",
  "kannada",
  "malayalam",
  "oriya",
];
